import { render, staticRenderFns } from "./ContactsWidget.vue?vue&type=template&id=2a14164d&scoped=true&"
import script from "./ContactsWidget.vue?vue&type=script&lang=js&"
export * from "./ContactsWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContactsWidget.vue?vue&type=style&index=0&id=2a14164d&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a14164d",
  null
  
)

export default component.exports